module.exports = __webpack_public_path__ + "static/media/talking_greeting.6b350aa9.gif";